import { Component } from '@angular/core';
import { NewsServiceService } from 'src/app/service/news-service.service';
import { PostsService } from 'src/app/service/posts.service';

@Component({
  selector: 'app-view-all-post-by-user',
  templateUrl: './view-all-post-by-user.component.html',
  styleUrl: './view-all-post-by-user.component.scss'
})
export class ViewAllPostByUserComponent {

  singleBlogPost:[];
      showFullMap: { [key: number]: boolean } = {};
      constructor(private postService:PostsService) {
          this.postService.getAllPostDetails().subscribe(res=>{
             // this.singleBlogPost = res;
               let data = res;
            this.singleBlogPost= data.sort((a, b) => b.id - a.id);
            console.log("this.singleBlogPost "+JSON.stringify(this.singleBlogPost));
          })
       }
  
      ngOnInit(): void {
      }
  
      sectionTitle = [
          {
              title: "Our Latest Posts",
              
          }
      ]
}
